import React from 'react';
import { Modal, Form, Input } from 'antd';


//export default class IngresoObservacionModal extends React.Component {
class IngresoObservacionModal extends React.Component {
    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };
    handleOk = (e) => {
        debugger
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                debugger
                const form = {
                    observacionRechazo: values.observacion,
                    id: this.props.formValues.iD
                };

                this.props.onSave(form, this.props.form);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                title={"Rechazar solicitud de requerimiento"}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                width="800px"
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación de rechazo">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion,
                                    rules: [{
                                        required: true,
                                        message: 'Requerido',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(IngresoObservacionModal)